module.exports = { "default": require("core-js/library/fn/number/min-safe-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/min-safe-integer.js
// module id = 1010
// module chunks = 1